<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="conversation-not-included">
<h1>Conversation Not Included</h1>
<p>Five years at Dental School led to a brief period in General Dental Practice. I quickly discovered that to earn a living as a General Dental practitioner one could not have a conversation with one’s patients. Gifted as many of my patients were, it was beyond the most talented to converse with a mouth full of cotton wool, a sucker and a screeching high speed dental drill. In contrast, chatty and attractive as my dental nurse was, endless conversation about TV soap operas and ladies magazines did not fill my need for engagement with fellow beings. Conversational silence was not, for me, golden. I had read that amongst all professions suicide was most common amongst Dentists. I began to understand why and turned to music and radio in the surgery as a way of mitigating my verbal isolation. The benefits were minimal and I worried that if I felt like this after a matter of weeks how would I feel after thirty years—if I lasted that long.</p>
<p>In desperation, I turned to my alma mater and applied for the post of Resident Dental House Officer, working for the Professor of Oral and Maxillo-Facial surgery. An anxious wait ended when I was invited for interview. It was a brief and informal affair and I left feeling uncertain about the outcome. Over the succeeding week I awaited the daily post with a mixture of anticipation and anxiety. My relief was profound when I received an offer of the job. Several months later I found myself happily back in the old hunting grounds of my alma mater. There followed six months in which the first paving stones of my future career pathway were laid, including much conversation about all things surgical.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch017.vue?06ab6434